<template>
  <div id="goods">
    <!-- <div style="width:200px">
      <el-input v-model="search" size="large" placeholder="店铺名称搜索" />
    </div> -->
    <div class="comond_btn">
      <el-button @click="dialogVisible = true">添加店铺</el-button>
    </div>
    <template>
      <!-- 列表 -->
      <el-table
        :data="tableData.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
        style="width: 100%"
      >
        <el-table-column label="店铺logo">
          <template width="100" slot-scope="scope">
            <img style="width:60px;height:60px;border:none;" :src="scope.row.logo" />
          </template>
        </el-table-column>
        <el-table-column label="店铺名称" prop="name"></el-table-column>
        <el-table-column label="首字母" prop="firstLetter"></el-table-column>
        <el-table-column label="商品数量" prop="productCount" :formatter="productCount"></el-table-column>
        <el-table-column label="评论数量" prop="productCommentCount" :formatter="productCommentCount"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleDetail(scope.$index, scope.row)">查看</el-button>
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <!-- 添加店铺dialog -->
    <div>
      <el-dialog
        title="添加店铺"
        :visible.sync="dialogVisible"
        width="30%"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <el-form :model="form" :rules="rules" ref="form">
          <el-form-item label="店铺logo(525*525)" :label-width="formLabelWidth">
            <el-upload
              class="avatar-uploader"
              :data="qiniu"
              action="https://upload-z0.qiniup.com"
              :show-file-list="false"
              :multiple="false"
              :before-upload="(file) => { return handleBeforeUpload(file, 'brandLogo') }"
              :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'brandLogo') }"
            >
              <img v-if="imgUrl" :src="imgUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="品牌故事背景(750*300)" :label-width="formLabelWidth">
            <el-upload
              class="avatar-uploader"
              :data="qiniu"
              action="https://upload-z0.qiniup.com"
              :show-file-list="false"
              :multiple="false"
              :before-upload="(file) => { return handleBeforeUpload(file, 'brandback') }"
              :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'brandback') }"
            >
              <img v-if="backImgUrl" :src="backImgUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>

          <el-form-item label="店铺名称" prop="name" :labelWidth="formLabelWidth">
            <el-input v-model="form.name" clearable></el-input>
          </el-form-item>
          <el-form-item label="首字母" :labelWidth="formLabelWidth">
            <el-input v-model="form.firstLetter" clearable></el-input>
          </el-form-item>
          <el-form-item label="品牌介绍" :labelWidth="formLabelWidth">
            <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="form.brandStoryText"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handCancer()">取 消</el-button>
          <el-button type="primary" @click="handleSave()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 编辑店铺dialog -->
    <div>
      <el-dialog
        title="编辑店铺"
        :visible.sync="editDialogVisible"
        width="30%"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <el-form :model="ruleForm">
          <el-form-item label="店铺logo" :label-width="formLabelWidth">
            <el-upload
              class="avatar-uploader"
              :data="qiniu"
              action="https://upload-z0.qiniup.com"
              :show-file-list="false"
              :multiple="false"
              :before-upload="(file) => { return handleBeforeUpload(file, 'brandLogo') }"
              :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'brandLogo') }"
            >
              <img v-if="imgUrl" :src="imgUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="品牌故事背景(750*300)" :label-width="formLabelWidth">
            <el-upload
              class="avatar-uploader"
              :data="qiniu"
              action="https://upload-z0.qiniup.com"
              :show-file-list="false"
              :multiple="false"
              :before-upload="(file) => { return handleBeforeUpload(file, 'brandback') }"
              :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'brandback') }"
            >
              <img v-if="backImgUrl" :src="backImgUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>

          <el-form-item label="店铺名称" :labelWidth="formLabelWidth">
            <el-input v-model="ruleForm.name" clearable></el-input>
          </el-form-item>
          <el-form-item label="首字母" :labelWidth="formLabelWidth">
            <el-input v-model="ruleForm.firstLetter" clearable></el-input>
          </el-form-item>
          <el-form-item label="品牌介绍" :labelWidth="formLabelWidth">
            <el-input
              type="textarea"
              :rows="3"
              placeholder="请输入内容"
              v-model="ruleForm.brandStoryText"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleEditSubmit()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 查看店铺dialog -->
    <div>
      <el-dialog title="店铺详情" :visible.sync="detaildialogVisible" width="50%">
        <!-- 详情内容 -->
        <el-descriptions class="margin-top" title :column="2" :size="size" border>
          <el-descriptions-item>
            <template slot="label">店铺Logo</template>
            <el-image style="width: 100px; height: 100px" :src="detailData.logo"></el-image>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">店铺名称</template>
            {{detailData.name}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">首字母</template>
            {{detailData.firstLetter}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">是否为品牌制造商</template>
            {{detailData.factoryStatus===0?"不是":"是"}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">商品总数</template>
            {{detailData.productCount===null?0:detailData.productCount}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">评论数量</template>
            {{detailData.productCommentCount===null?0:detailData.productCommentCount}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">品牌故事背景图</template>
            <el-image style="width: 100px; height: 100px" :src="detailData.bigPic"></el-image>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">品牌故事</template>
            {{detailData.brandStory===null?"暂无数据":detailData.brandStory}}
          </el-descriptions-item>
        </el-descriptions>

        <span slot="footer" class="dialog-footer">
          <el-button @click="detaildialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="detaildialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <div style="margin-top:30px ;text-align:center; ">
      <el-pagination
        background
        layout="total, prev, pager, next"
        @current-change="handelCurrentChange"
        :current-page="currentpageIndex"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { queryBrandList, qiniuupload, addBrand, updateBrand } from '../../api'
import moment from 'moment'
export default {
  data () {
    return {
      rules: {
        name: [
          { required: true, message: '请输入店铺名称', trigger: 'blur' },
        ],
      },
      size: '',
      detailData: [],
      total: 0,
      currentpageIndex: 1,
      currentpageSize: 10,
      // 品牌背景图
      backImgUrl: '',
      imgUrl: '',//解决图片回显问题
      uploadUrl: '', //  七牛上传地址前缀
      qiniu: { //  qiniu
        token: '',
        key: ''
      },
      formLabelWidth: '160px',
      // 添加店铺默认关闭弹框
      dialogVisible: false,
      // 详情弹框
      detaildialogVisible: false,
      // 编辑弹框
      editDialogVisible: false,
      // 查询
      search: '',
      // 列表数据
      tableData: [],
      // 初始化
      form: {
        name: '',
        firstLetter: '',
        brandStoryText: ''
      },
      ruleForm: {
        id: '',
        name: '',
        firstLetter: '',
        brandStoryText: ''
      }
    }
  },
  methods: {
    // props属性动态
    productCount (row, column) {
      if (row.productCount === null) {
        return 0
      } else {
        return row.productCount
      }
    },
    productCommentCount (row, column) {
      if (row.productCommentCount === null) {
        return 0
      } else {
        return row.productCommentCount
      }
    },
    handCancer () {
      this.dialogVisible = false
      this.imgUrl = ''
      this.backImgUrl = ''
    },
    // 添加店铺确定提交
    handleSave () {
      let para = new URLSearchParams()
      para.append('name', this.form.name)
      para.append('firstLetter', this.form.firstLetter)
      para.append('brandStoryText', this.form.brandStoryText)
      para.append('logo', this.imgUrl)
      para.append('bigPic', this.backImgUrl)
      //请求接口
      addBrand(para).then(data => {
        console.log(data);
        if (data.code === 10000) {
          this.$message({
            message: data.msg,
            type: 'success'
          })
          //关闭弹窗
          this.dialogVisible = false
          this.imgUrl = ''
          this.backImgUrl = ''
          this.form = {
            name: '',
            firstLetter: '',
            brandStoryText: ''
          },
            this.queryBrandList()
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    // 七牛部分
    getToken () {
      let para = new URLSearchParams()
      para.append('bucket', 'productpic')
      qiniuupload(para).then((res) => {
        // console.log(res.data)
        this.qiniu.token = res.data.token
        this.uploadUrl = res.data.bucketUrl
      })
    },
    handleOnSuccess (response, file, fileList, obj) { //  上传成功之后
      // console.log(response, file, fileList, obj)
      // this.form[obj] = this.uploadUrl +'/'+ response.key
      // console.log(this.form[obj])
      if (obj === "brandback") {
        this.backImgUrl = this.uploadUrl + '/' + response.key
      } else {
        this.imgUrl = this.uploadUrl + '/' + response.key
      }
    },
    handleBeforeUpload (file, obj) { //  上传之前
      this.qiniu.key = obj + `${moment().format('YYYYMMDDHHmmSSS')}${Number.parseInt(Math.random() * 1000, 10)}.${file.type.split('/')[1]}`
    },
    //查看
    handleDetail (index, row) {
      // row 就是当前条目的对象
      // console.log(index, row);
      this.detaildialogVisible = true
      this.detailData = row

    },
    // 编辑点击事件
    handleEdit (index, row) {
      console.log(row);
      this.editDialogVisible = true
      this.imgUrl = row.logo
      this.backImgUrl = row.bigPic
      this.ruleForm.id = row.id
      this.ruleForm.name = row.name
      this.ruleForm.firstLetter = row.firstLetter
      this.ruleForm.brandStoryText = row.brandStory
    },
    // 编辑提交
    handleEditSubmit () {
      let para = new URLSearchParams()
      para.append('id', this.ruleForm.id)
      para.append('name', this.ruleForm.name)
      para.append('firstLetter', this.ruleForm.firstLetter)
      para.append('brandStoryText', this.ruleForm.brandStoryText)
      para.append('logo', this.imgUrl)
      para.append('bigPic', this.backImgUrl)
      para.append('showStatus', 1)
      updateBrand(para).then(data => {
        // console.log(data);
        if (data.code === 10000) {
          this.$message({
            message: data.msg,
            type: 'success'
          })
          this.editDialogVisible = false
          this.queryBrandList()
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })

    },
    handleDelete (index, row) {
      // row  当前点击条目
      let para = new URLSearchParams()
      para.append("id", row.id)
      para.append("showStatus", 2)
      updateBrand(para).then(data => {
        if (data.code === 10000) {
          this.$message({
            message: data.msg,
            type: 'success'
          })
          this.queryBrandList()
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    // 查询列表
    queryBrandList () {
      let para = new URLSearchParams()
      para.append('pageIndex', this.currentpageIndex)
      para.append('pageSize', this.currentpageSize)
      //请求接口
      queryBrandList(para).then(data => {
        // console.log(data);
        if (data.code === 10000) {
          this.tableData = data.data.rows
          this.total = data.data.total
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    handelCurrentChange (i) { // 分页
      console.log(i);
      this.currentpageIndex = i
      this.queryBrandList()
    },
  },
  //生命周期
  mounted () {
    this.queryBrandList()
    // 获取七牛token
    this.getToken()
  }
}

</script>
<style lang="stylus">
#goods {
  .comond_btn {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;

    button {
      background-color: #0a3d5f;
      color: #fff;
    }
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
</style>
